export const SIDEBAR_MIN_WIDTH = 240;
export const TOP_HEADER_HEIGHT = 64;
